import { ProductFormCard, ProductFormData } from '@/components/seller/products/ProductFormCard';

type EcoPackSize = 'S' | 'M' | 'L' | 'XL';

export interface EcoPackTemplate extends ProductFormData {
  size?: EcoPackSize;
  templateType?: 'preset' | 'custom';
  clientId?: string;
  selected?: boolean;
}

interface EcoPackTemplateSectionProps {
  templates: EcoPackTemplate[];
  onChange: (index: number, template: EcoPackTemplate) => void;
  onAdd: (size: EcoPackSize) => void;
  onAddCustom: () => void;
  onRemove: (index: number) => void;
  showValidation?: boolean;
  fallbackImageUrl?: string;
}

const ALL_SIZES: EcoPackSize[] = ['S', 'M', 'L', 'XL'];

export function EcoPackTemplateSection({
  templates,
  onChange,
  onAdd,
  onAddCustom,
  onRemove,
  showValidation = false,
  fallbackImageUrl
}: EcoPackTemplateSectionProps) {
  const hasSize = (size: EcoPackSize) =>
    templates.some(t => t.templateType !== 'custom' && t.size === size);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-800">에코팩 템플릿</h3>
        <div className="flex gap-2">
          {ALL_SIZES.map(size => !hasSize(size) && (
            <button
              key={size}
              onClick={() => onAdd(size)}
              className="px-3 py-2 text-sm font-medium text-green-700 bg-green-50 hover:bg-green-100 rounded-lg border border-green-200"
            >
              + 에코팩 {size}
            </button>
          ))}
          <button
            onClick={onAddCustom}
            className="px-3 py-2 text-sm font-medium text-green-700 bg-white hover:bg-green-50 rounded-lg border border-green-200"
          >
            + 커스텀 템플릿
          </button>
        </div>
      </div>

      <div className="space-y-3">
        {templates.map((template, index) => {
          const isSelected = template.selected !== false;
          return (
            <ProductFormCard
              key={`${template.id || template.clientId || template.size || index}`}
              product={template}
              onChange={(updated) => onChange(index, {
                ...updated,
                size: template.size,
                templateType: template.templateType,
                clientId: template.clientId,
                selected: template.selected
              })}
              onDelete={() => onRemove(index)}
              showDeleteButton={true}
              showCheckbox={true}
              selected={isSelected}
              onSelect={(selected) => onChange(index, {
                ...template,
                selected
              })}
              showValidation={showValidation}
              showDiscountControls={true}
              discountType="deadline"
              fallbackImageUrl={fallbackImageUrl}
              invalidFields={{
                price: isSelected && !template.originalPrice,
                stock: isSelected && !template.stock,
                name: isSelected && !template.name
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
